import React from "react";
import video from "../../assets/bg-universe.mp4";
import fallbackImage from "../../assets/fallback-image.png";
import "../../styles/background.css";

const Background = () => {
  return (
    <>
      <div className="shadow-overlay"></div>
      <video
        playsInline
        autoPlay
        muted
        loop
        preload="auto"
        id="background"
        poster={fallbackImage}
      >
        <source src={video} type="video/mp4" />
      </video>
    </>
  );
};

export default Background;
